import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  BorderColorProps,
  BorderRadiusProps,
  BorderStyleProps,
  BorderWidthProps,
  PositionProps,
} from 'styled-system';
import {
  backgroundColor,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidth,
  position,
  space,
} from 'styled-system';

import type { BackgroundColorProps, SpaceProps } from '../theme/system-types';

const UnstyledContainerWithBackground = styled.div<
  SpaceProps &
    BackgroundColorProps &
    BorderRadiusProps &
    BorderColorProps &
    BorderWidthProps &
    BorderStyleProps &
    PositionProps
>`
  ${space};
  ${backgroundColor};
  ${borderRadius};
  ${borderStyle};
  ${borderColor};
  ${borderWidth};
  ${position};
`;

export const containerWithBackgroundStyles: ComponentProps<typeof UnstyledContainerWithBackground> =
  {
    backgroundColor: 'sys.neutral.background.default',
    px: ['sp_16', 'sp_24', 'sp_16', 'sp_24'],
    py: 'sp_24',
    pt: 'sp_24',
    pb: 'sp_24',
    borderRadius: 'medium',
  };

const ContainerWithBackground = (props: ComponentProps<typeof UnstyledContainerWithBackground>) => (
  <UnstyledContainerWithBackground {...containerWithBackgroundStyles} {...props} />
);

export default ContainerWithBackground;
